module.exports = __webpack_public_path__ + "img/symbol_4.5e40acdc.png";